import { Box, Typography, Dialog, Slide, IconButton, Button } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { closeOverlayAndResetHowTo } from '../redux/UIOverlayPersonalSizeRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { sendWebsiteEventMessage } from '../telegrambotevents';
import OverlayComponentButton from './OverlayComponentButton';
import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';
import React from 'react';
import { TransitionProps } from '@material-ui/core/transitions';
import { Close } from '@material-ui/icons';
import { Player } from '@lottiefiles/react-lottie-player';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContainer: {
      zIndex: ((theme.zIndex.modal + 1) + " !important") as any,
      '& .MuiPaper-root': {
        width: "80vw",
        borderRadius: "5.4vw",
        // backgroundColor: "#090F17"
      },
      '& .MuiBackdrop-root': {
        backgroundColor: "rgba(0, 0, 0, 0.7)"
      } 
    },
    dialogContentContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px 0px 0px',
      // textAlign: 'center',
    },
    dialogDivImage: {
      width: "100%",
      // height: "124vw",
      overflow: "hidden",
      position: "relative",
      // backgroundColor: "#090F17",
    },
    backButton: {
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(2),
      backgroundColor: 'black',
      borderRadius: '50%',
      padding: theme.spacing(1),
    },
    backButtonIcon: {
      padding: '0',
      color: 'white',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      overflowY: 'hidden',
    },
    pageTitleHeader: {
      fontSize: '10px',
      letterSpacing: '0.05em',
      color: 'rgb(85, 85, 85)',
      fontWeight: 300,
    },
    pageTitle: {
      marginTop: '10px',
      fontSize: '20px',
      // width: '100%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '9px',
    },
  }),
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});
  

interface Props {
}

export default function OverlayView({}: Props) {
  const overlayView = useAppSelector(state => state.overlayPersonalSize);
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const classes = useStyles();

  function handleClose() {
    dispatch(closeOverlayAndResetHowTo());
    sendWebsiteEventMessage("[PERSONAL FIT] How To Ditutup");
  }
  
  return (
  <Dialog
    open={overlayView.statusHowTo === UIOverlayViewStatus.On}
    TransitionComponent={Transition}
    // keepMounted
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    onClose={() => handleClose()}
    className={classes.dialogContainer}>
      <div className={classes.dialogContentContainer}>
        <div className={classes.dialogDivImage}>
          <Box className={classes.dialogContent}>
            <Typography className={classes.pageTitleHeader} style={{ padding: '0px 18px' }}>
              PAKAI UKURAN PERSONAL
            </Typography>
            <Typography className={classes.pageTitle} style={{ padding: '0px 18px',
              textUnderlineOffset: '3px'
             }}>
              <u>Ukuran Personal Kamu</u><br/>Sudah Siap!
            </Typography>
            <Typography className={classes.pageItemDescription} style={{margin: '10px 0px 15px', color: 'rgb(122,122,122)', fontWeight: 300, letterSpacing: '0.1vw', padding: '0px 18px' }}>
              Pilih produk yang kamu mau, dan pilihan Pakai Ukuran<br/>Personal akan muncul saat <u style={{textUnderlineOffset: '3px'}}>kamu membuat ukuran baru.</u>
            </Typography>
            <video 
            autoPlay muted loop playsInline
            style={{
              width: '90%',
              marginLeft: '5%',
              borderRadius: '4%',
              border: '1px solid #e1e1e1',
            }}
            src={'https://studiosclo.uk/general/HowToUse_ProfilPersonalFit_1_cropped.mp4'}/>
            <Box style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: '10px', marginTop: '5px'}}>
              <Button style={{
                color: 'white',
                backgroundColor: '#121212',
                borderRadius: '30px',
                padding: '8px 15px 4px 15px',
                fontSize: '11px',
                letterSpacing: '0.7px',
                margin: '10px 23px'
              }}
              onClick={handleClose}
              >
                MULAI PAKAI
              </Button>
            </Box>
          </Box>
      </div>
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => handleClose()}
          style={{ position: 'absolute', top: '1px', right: '12px' }}
        >
          <Close />
        </IconButton>
    </div>
  </Dialog>);
}